import './datepicker-highlighter.scss';
const DIRECTIVE_NAME = DatepickerHighlighter.DIRECTIVE_NAME = 'ktDatepickerHighlighter';
export default function DatepickerHighlighter($timeout) {
    'ngInject';

    const SELECTOR_DAY = '.mighty-picker-calendar__day';
    const SELECTOR_CALENDAR_POPUP = '.mighty-picker__holder';
    const SELECTOR_PICKER_MONTH = '.mighty-picker__month';
    const SELECTOR_PICKER_MONTH_NAME = '.mighty-picker__month-name';

    const CLASS_DAY_WRAPPER = 'mighty-picker-calendar__day-wrapper';
    const CLASS_DAY_DISABLED = 'mighty-picker-calendar__day--disabled';
    const CLASS_HIGHLIGHTED_BOUNDARY = 'highlighted-boundary';
    const CLASS_HIGHLIGHTED = 'highlighted';

    const EVENT_MOUSEOVER = 'mouseover';
    const EVENT_CLICK = 'click';

    const MONTH = 'month';
    const MONTH_FORMAT_IN_POPUP_HEADER = 'MMMM YYYY';

    return {
        restrict: 'A',
        require: ['mightyDatepicker'],
        link: function($scope, $elem, $attrs, [mightyDatepickerCtrl]) {
            $scope.$watch(() => mightyDatepickerCtrl.getVisibility(), (visible) => {
                if (visible) {
                    $timeout(onVisible);
                }
            });

            function onVisible() {
                let anotherDate = getAnotherDate();
                let selectedDate = getSelectedDate();
                highlight(anotherDate, selectedDate);

                getCalendarPopup().on(EVENT_MOUSEOVER, onEvent);
                getCalendarPopup().on(EVENT_CLICK, onEvent);

                function onEvent(event) {
                    const dateElement = angular.element(event.target);
                    if (isDateSelected()) {
                        anotherDate = getAnotherDate();
                        selectedDate = getSelectedDate();
                        highlight(anotherDate, selectedDate);
                    } else if (dateElement.hasClass(CLASS_DAY_WRAPPER) && !dateElement.parent().hasClass(CLASS_DAY_DISABLED)) {
                        anotherDate = getAnotherDate();
                        const hoveredDateRaw = dateElement.parent().attr('date');
                        const hoveredDate = moment(new Date(hoveredDateRaw));
                        highlight(anotherDate, hoveredDate);
                    }
                }
            }

            function getAnotherDate() {
                return moment($scope.$eval($attrs[DIRECTIVE_NAME]), mightyDatepickerCtrl.getOptions().dateFormat);
            }

            function isDateSelected() {
                return mightyDatepickerCtrl.getModel();
            }

            function getSelectedDate() {
                return moment(mightyDatepickerCtrl.getModel(), mightyDatepickerCtrl.getOptions().dateFormat);
            }

            function getCalendarPopup() {
                return angular.element(SELECTOR_CALENDAR_POPUP);
            }

            function highlight(firstDate, secondDate) {
                const startDate = firstDate > secondDate ? secondDate : firstDate;
                const endDate = firstDate > secondDate ? firstDate : secondDate;

                getCalendarPopup().find(SELECTOR_DAY).each((index, element) => {
                    const rawDate = angular.element(element).attr('date');
                    const date = moment(new Date(rawDate));
                    const rawMonth = angular.element(element)
                        .closest(SELECTOR_PICKER_MONTH)
                        .children(SELECTOR_PICKER_MONTH_NAME)
                        .text();
                    const calendarMonth = moment(rawMonth, MONTH_FORMAT_IN_POPUP_HEADER);

                    const isStart = date.isSame(startDate) && calendarMonth.isSame(startDate, MONTH);
                    const isEnd = date.isSame(endDate) && calendarMonth.isSame(endDate, MONTH);
                    const isBetween = date.isBetween(startDate, endDate);

                    angular.element(element).toggleClass(CLASS_HIGHLIGHTED_BOUNDARY, isStart || isEnd);
                    angular.element(element).toggleClass(CLASS_HIGHLIGHTED, isBetween);
                });
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/datepicker-highlighter/datepicker-highlighter-directive.js